import { Container, Graphics, Text } from 'pixi.js';
import { theme } from '../config/theme';
import type { BeaconDef } from '../config/beacons';

export class Beacon extends Container {
  private gfx: Graphics;
  private nameLabel: Text;
  public def: BeaconDef;
  private pulseTime = 0;

  constructor(def: BeaconDef, w: number, h: number) {
    super();
    this.def = def;
    this.x = def.x * w;
    this.y = def.y * h;

    this.gfx = new Graphics();
    this.addChild(this.gfx);

    this.nameLabel = new Text({
      text: def.label,
      style: {
        fontFamily: theme.fonts.label,
        fontSize: 10,
        fill: theme.colors.label,
        align: 'center',
      },
    });
    this.nameLabel.anchor.set(0.5, 0);
    this.nameLabel.y = theme.sizes.beaconRadius + 4;
    this.nameLabel.alpha = 0.7;
    this.addChild(this.nameLabel);

    this.idleShape();
  }

  private idleShape() {
    this.gfx.clear();
    const r = this.def.isPort ? theme.sizes.portRadius : theme.sizes.beaconRadius;
    this.gfx.fill(theme.colors.beaconIdle);
    this.drawOctagon(r);
  }

  private drawOctagon(r: number) {
    const pts: number[] = [];
    for (let i = 0; i < 8; i++) {
      const a = (i / 8) * Math.PI * 2 + this.pulseTime * theme.animation.beaconIdlespeed;
      pts.push(Math.cos(a) * r, Math.sin(a) * r);
    }
    this.gfx.poly(pts);
    this.gfx.fill();
  }

  flash(granted: boolean) {
    const color = granted ? theme.colors.flashGranted : theme.colors.flashDenied;
    const r = (this.def.isPort ? theme.sizes.portRadius : theme.sizes.beaconRadius) * theme.sizes.beaconFlashScale;

    this.gfx.clear();
    this.gfx.fill(color);
    this.drawOctagon(r);

    setTimeout(() => {
      this.gfx.clear();
      this.idleShape();
    }, theme.animation.beaconPulseMs);
  }

  tick(_dt: number) {
    this.pulseTime += 1;
    // Subtle rotation
    this.rotation = this.pulseTime * theme.animation.beaconIdlespeed;
  }
}
